/* eslint import/prefer-default-export: off */

import { ReduxAction, reduxTypes } from '../types'

export function update(url: URL): ReduxAction<URL> {
  return {
    payload: url,
    type: reduxTypes.FORM_REDIRECT_UPDATE,
  }
}
